var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',_vm._b({attrs:{"disabled":!_vm.link || !this.currentProduct,"href":_vm.link}},'b-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }